export default {
  props: {
    type: {
      type: 'enum',
      values: ['placeholder']
    },
    attrs: {
      props: {
        text: {
          type: 'string'
        }
      }
    }
  }
};